import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const stocksJourneyRoutes = [
  {
    id: 'stocks-sell',
    trackingName: 'Stocks Sell',
    path: 'dl/view/stocks/sell/:investmentEntityToken',
    lazy: async () => ({
      Component: (await import('../components/JourneyStocksSell')).JourneyStocksSell,
    }),
  },
  {
    id: 'stocks-buy',
    trackingName: 'Stocks Buy',
    path: 'dl/view/investing/buy/:investmentEntityToken',
    lazy: async () => ({
      Component: (await import('../components/JourneyInvestingBuy')).JourneyInvestingBuy,
    }),
  },
] as const satisfies JourneyRoute[]
